import { render, staticRenderFns } from "./InvoicesReports.vue?vue&type=template&id=52f0169d&scoped=true"
import script from "./InvoicesReports.vue?vue&type=script&lang=js"
export * from "./InvoicesReports.vue?vue&type=script&lang=js"
import style0 from "./InvoicesReports.vue?vue&type=style&index=0&id=52f0169d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f0169d",
  null
  
)

export default component.exports